// Imports
import AxiosConfig from './serverAxiosConfig'
import firebase from '../config/FirebaseConfig'

const getUniqueScreenshotsByPageId = async (pageId, options = {}) => {
  // Pull the current token off the user
  const { Aa: token } = firebase.auth().currentUser

  const { limit = 50, offset = 0 } = options

  const { data } = await AxiosConfig.get(
    `/screenshots/spyder/page/${pageId}/unique`,
    {
      params: {
        limit,
        offset
      },
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

export default {
  getUniqueScreenshotsByPageId
}
